import axios from "axios";
import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const Unsubscribe = () => {
  const location = useLocation();
  const email = location.pathname.split("/").at(-1);
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/candidate/unsubscribe/${email}`)
      .then((response) => {})
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {});
  }, []);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "110vh",
        flexDirection: "column",
      }}
      className="unsubscribe"
    >
      <div className="unsubscribeText">You've unsubscribed</div>
      <div className="unsubscribeText">
        You'll no longer receive emails from Spanidea
      </div>
      <Link to={"https://stagingcareers.spanidea.com/"}>
        <div className="unsubscribeText">Career Portal</div>
      </Link>
      {/* <div className="unsubscribeText">
        You have successfully Unsubscribed from job alerts.
      </div> */}
    </div>
  );
};

export default Unsubscribe;
